























































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import StarIcon from '../icons/StarIcon.vue';
import UmbrellaIcon from '../icons/UmbrellaIcon.vue';
import Rating from '../common/inputs/Rating.vue';
import Phases from '../common/inputs/Phases.vue';
import { SearchResultProcess } from '@/store/modules/searchInterfaces';
import { StatusLabels } from '@/models/status';
import { DomainLabels } from '@/models/domain';
import { TypeKeys } from '@/models/types';
import { ProcessModule } from '@/store/modules/process';

@Component({
  components: {
    StarIcon,
    UmbrellaIcon,
    Rating,
    Phases
  }
})
export default class SearchResult extends Vue {
  @Prop(Object)
  process!: SearchResultProcess;
  @Prop(Boolean)
  bookmarked!: boolean;
  @Prop(Boolean)
  noPhase!: boolean;

  processBookmarked = this.process.hasBookmarked;
  StatusLabels = StatusLabels;

  get isChildProcess() {
    return this.process.type === TypeKeys.CHILD;
  }

  get domains() {
    return this.process.domains.map(domain => DomainLabels[domain]).join(', ');
  }

  async setProcessBookmark() {
    // TODO not the way to do flow - action results should not be use for mutations directly in view. Actions should affect changes in state
    const res = await ProcessModule.setBookmarkFromSearch({
      id: this.process.id,
      hasBookmarked: !this.processBookmarked
    });
    this.processBookmarked = res ? !this.processBookmarked : this.processBookmarked;
  }
}
